export enum ContactsRequestTypes {
  GetOrgContactsRequest = 'contacts.org.get.request',
  GetOrgContactsSuccess = 'contacts.org.get.success',
  GetOrgContactsFailure = 'contacts.org.get.failure',
  UpdateOrgContactRequest = 'contacts.org.update.request',
  UpdateOrgContactSuccess = 'contacts.org.update.success',
  UpdateOrgContactFailure = 'contacts.org.update.failure',
  GetUmbrellaContactsRequest = 'contacts.umbrella.get.request',
  GetUmbrellaContactsSuccess = 'contacts.umbrella.get.success',
  GetUmbrellaContactsFailure = 'contacts.umbrella.get.failure',
  UpdateUmbrellaContactRequest = 'contacts.umbrella.update.request',
  UpdateUmbrellaContactSuccess = 'contacts.umbrella.update.success',
  UpdateUmbrellaContactFailure = 'contacts.umbrella.update.failure',
}
